import React from 'react';


export default class extends React.Component<{}> {

  render() {
    return (
      <div className="app-loading-bg">
        <div className='app-loading'>
          <span className="app-loading-dot">
            <i className="app-loading-dot-item"></i>
            <i className="app-loading-dot-item"></i>
            <i className="app-loading-dot-item"></i>
            <i className="app-loading-dot-item"></i>
          </span>
          <p style={{ transform: 'translateX(-20%)' }}>Loading</p>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/AppLoading/index.tsx